import React from 'react';
import { ConfidentialBanner } from './ConfidentialBanner';
import { HeroSection } from './HeroSection';
import { RevealSection } from './RevealSection';
import { ProfitBreakdownSection } from './ProfitBreakdownSection';
import { BenefitsSection } from './BenefitsSection';
import { MidCTA } from './MidCTA';
import { SocialProofSection } from './SocialProofSection';
import { WhoIsThisForSection } from './WhoIsThisForSection';
import { ObjectionsSection } from './ObjectionsSection';
import { UrgencySection } from './UrgencySection';
import { CTASection } from './CTASection';
import { Link } from 'react-router-dom';
export function SalesPage() {
  return <div className="min-h-screen bg-[#0f1724] text-[#f5f0e8] font-sans selection:bg-[#c9a84c] selection:text-[#0f1724]" data-id="element-165">
      <ConfidentialBanner data-id="element-166" />
      <main data-id="element-167">
        <HeroSection data-id="element-168" />
        <RevealSection data-id="element-169" />
        <ProfitBreakdownSection data-id="element-170" />
        <BenefitsSection data-id="element-171" />
        <MidCTA data-id="element-172" />
        <SocialProofSection data-id="element-173" />
        <WhoIsThisForSection data-id="element-174" />
        <ObjectionsSection data-id="element-175" />
        <UrgencySection data-id="element-176" />
        <CTASection data-id="element-177" />
      </main>

      <footer className="py-12 px-4 text-center text-[#f5f0e8]/40 text-sm border-t border-[#c9a84c]/10 bg-[#0a0f1a]" data-id="element-178">
        <div className="max-w-4xl mx-auto space-y-8" data-id="element-179">
          <div className="space-y-4" data-id="element-180">
            <p className="text-xs leading-relaxed max-w-2xl mx-auto" data-id="element-181">
              DISCLAIMER: Results shown are not typical. Your results will vary
              based on your background, experience, and effort. This product is
              for educational purposes only and is not financial or legal
              advice. All business entails risk.
            </p>
            <p data-id="element-182">© 2025 The Shadow Rental Method. All Rights Reserved.</p>
          </div>

          <div className="flex flex-wrap justify-center gap-4 md:gap-8 text-xs font-medium" data-id="element-183">
            <Link to="/privacy" className="hover:text-[#c9a84c] transition-colors" data-id="element-184">
              Privacy Policy
            </Link>
            <Link to="/terms" className="hover:text-[#c9a84c] transition-colors" data-id="element-185">
              Terms of Service
            </Link>
            <Link to="/disclaimer" className="hover:text-[#c9a84c] transition-colors" data-id="element-186">
              Earnings Disclaimer
            </Link>
          </div>
        </div>
      </footer>
    </div>;
}